import { supabase } from "@/integrations/supabase/client";
import { APP_VERSION, APP_BUILD_HASH, APP_BUILD_NOTES } from "@/lib/version";

const STORAGE_KEY = "archivio-coltella-registered-build";

/**
 * Registers the current build as a deployment the first time this build is
 * loaded on any client. Uses a UNIQUE(build_hash) constraint on the server
 * for global dedup, and localStorage for per-browser dedup to avoid extra
 * network calls.
 *
 * Fire-and-forget: silently swallows errors so it never blocks the app.
 */
export async function registerDeployment(): Promise<void> {
  try {
    if (typeof window === "undefined") return;
    if (APP_BUILD_HASH === "dev") return; // don't record dev sessions

    const already = window.localStorage.getItem(STORAGE_KEY);
    if (already === APP_BUILD_HASH) return;

    const { error } = await supabase.from("app_deployments").insert({
      version: APP_VERSION,
      build_hash: APP_BUILD_HASH,
      notes: APP_BUILD_NOTES || null,
    });

    // 23505 = unique_violation → another client already registered this build.
    // Treat as success.
    if (error && (error as { code?: string }).code !== "23505") {
      // Not throwing — versioning must never break the app.
      // eslint-disable-next-line no-console
      console.warn("[versioning] Could not register deployment:", error.message);
    }

    window.localStorage.setItem(STORAGE_KEY, APP_BUILD_HASH);
  } catch {
    // Silent
  }
}
